import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card, Container, Table} from 'react-bootstrap';
import Sidebar from './Sidebar';
import ToastConfirmation from './ToastConfirmation';
import configAdmin from './configAdmin.json';
import {
  getMainConfig,
  getAllLinks,
  updateFormConfig,
  getSegregationVariables,
  getDerivedVariables,
  getFilterVariables,
  getLayersConfig,
  updateDerivedVariable,
  deleteDerivedVariable,
  addDerivedVariables
} from './apiCalls';

const { HOMEPAGE_CODE, LINKS_RRSS, ODISEA_FORM } = configAdmin

export default function DerivedFeaturesEdit() {

  const [showToaster, setShowToaster] = useState(false);
  const [mainConfig, setMainConfig] = useState({});
  const [allLinks, setAllLinks] = useState([]);
  const [derivedVariables, setDerivedVariables] = useState([]);
  const [filterVariables, setFilterVariables] = useState([]);
  const [segregationVariables, setSegregationVariables] = useState([]);
  const [layersConfig, setLayersConfig] = useState({});
  const [derivedVariablesFormData, setDerivedVariablesFormData] = useState([]);
  const [selectedDerivedVariable, setSelectedDerivedVariable] = useState();

  useEffect(() => {
    getMainConfig(setMainConfig);
    getAllLinks(setAllLinks);
    getSegregationVariables().then(setSegregationVariables);
    getDerivedVariables().then(setDerivedVariables);
    getFilterVariables().then(setFilterVariables);
    getLayersConfig(setLayersConfig);
  }, []);

  const saveDerivedVariable = (id) => {
    if (derivedVariablesFormData.hasOwnProperty(id)) {
      updateDerivedVariable(id, derivedVariablesFormData[id])
        .then(() => getDerivedVariables())
        .then(updatedVariables => {
          setDerivedVariables(updatedVariables);
          setSelectedDerivedVariable(null);
          // Explicitly handle potential undefined selectedDerivedVariable
          if (selectedDerivedVariable) {
            const updatedSelectedVar = updatedVariables.find(v => v.id === selectedDerivedVariable.id);
            if (updatedSelectedVar) {
              setSelectedDerivedVariable(updatedSelectedVar);
            }
          }
          setShowToaster(true);
        })
        .catch((error) => {
          console.error("An error occurred while saving the variable:", error);
        });
    }
  };



  const handleDeleteDerivedVariable = (id) => {
    deleteDerivedVariable(id)
      .then(() => getDerivedVariables())
      .then(updatedVariables => {
        setDerivedVariables(prevDerivedVariables => 
          prevDerivedVariables.filter((item) => item.id !== id)
        );
        setDerivedVariablesFormData(prevFormData => 
          Object.keys(prevFormData)
            .filter(key => key !== id)
            .reduce((obj, key) => {
              return {
                ...obj,
                [key]: prevFormData[key]
              };
            }, {})
        );
        setSelectedDerivedVariable(null);
        setShowToaster(true);
      })
      .catch(error => {
        console.error("An error occurred when deleting the variable:", error);
      });
  };


  const handleAddDerivedVariable = () => {
    const newVariable = {
      variableName: "Nombre de variable",
      selectLabel: "Etiqueta de variable",
      checkGroupLabel: "Etiqueta de variable",
      checkItems: [
        { variableValue: "1", label: "Item de ejemplo 1" },
        { variableValue: "2", label: "Item de ejemplo 2" }
      ]
    };
  
    addDerivedVariables([newVariable])
      .then(() => getDerivedVariables())
      .then(updatedVariables => {
        setDerivedVariables(updatedVariables);
        setShowToaster(true);
      })
      .catch(error => {
        console.error("An error occurred:", error);
      });
  };

  const handleDeleteDerivedOption = (id) => {

    let formData = selectedDerivedVariable;
    formData.checkItems = formData.checkItems.filter((item, itemId) => itemId !== id)

    setDerivedVariablesFormData({
      ...derivedVariablesFormData,
      [selectedDerivedVariable.id]: formData
    });

    setSelectedDerivedVariable(formData);

    updateDerivedVariable(selectedDerivedVariable.id, formData)
      .then(() => getDerivedVariables(setDerivedVariables))
      .then(() => setShowToaster(true));
    
  }

  const handleAddDerivedOption = () => {
    let formData = {...selectedDerivedVariable};
    formData.checkItems.push({"variableValue":"NUEVO VALOR","label":"NUEVO ITEM"});
  
    updateDerivedVariable(selectedDerivedVariable.id, formData)
      .then(() => getDerivedVariables())
      .then(setDerivedVariables)
      .then(() => {
        setShowToaster(true);
      });
  };


  const derivedFormContent = (
    <>
    <ToastConfirmation showToaster={showToaster} setShowToaster={ setShowToaster } message={ 'Contenido guardado con éxito!' }/>
    <Form>
      <Form.Group className="admin-content-group">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Variable</th>
            <th>Label</th>
            <th>Operaciones</th>
          </tr>
        </thead>
        <tbody>
          {
            derivedVariables && derivedVariables.map((item, itemId) => {
              return (
                <tr>
                  <td>{/*itemId + 1*/ item.id}</td>
                  <td>
                    <Form.Control
                      placeholder="Etiqueta de variable"
                      defaultValue={ item.variableName }
                      value={ derivedVariablesFormData[item.id]?.variableName ? derivedVariablesFormData[item.id].variableName : item.variableName}
                      onChange={ (e) => {
                        setDerivedVariablesFormData({
                          ...derivedVariablesFormData,
                          [item.id] : {
                            'variableName': e.target.value,
                            'selectLabel': derivedVariablesFormData[item.id] ? derivedVariablesFormData[item.id]['selectLabel'] : item.selectLabel,
                            'checkGroupLabel': derivedVariablesFormData[item.id] ? derivedVariablesFormData[item.id]['checkGroupLabel'] : item.checkGroupLabel,
                            'checkItems': derivedVariablesFormData[item.id] ? derivedVariablesFormData[item.id]['checkItems'] : item.checkItems,
                          }
                        });
                      } }  
                    />
                  </td>
                  <td>
                    <Form.Control
                      placeholder="Alias"
                      defaultValue={ item.selectLabel }
                      value={ derivedVariablesFormData[item.id]?.selectLabel ? derivedVariablesFormData[item.id].selectLabel : item.selectLabel}
                      onChange={ (e) => {
                        setDerivedVariablesFormData({
                          ...derivedVariablesFormData,
                          [item.id] : {
                            'variableName': derivedVariablesFormData[item.id] ? derivedVariablesFormData[item.id]['variableName'] : item.variableName,
                            'selectLabel': e.target.value,
                            'checkGroupLabel': derivedVariablesFormData[item.id] ? derivedVariablesFormData[item.id]['checkGroupLabel'] : item.checkGroupLabel,
                            'checkItems': derivedVariablesFormData[item.id] ? derivedVariablesFormData[item.id]['checkItems'] : item.checkItems,
                          }
                        });
                      } }  
                    />
                  </td>
                  <td><Button _type="submit" className="admin-add-item-button" onClick={() => {saveDerivedVariable(item.id);}}>Guardar</Button> | <Button _type="submit" className="admin-delete-item-button" onClick={() => {handleDeleteDerivedVariable(item.id)}}>Eliminar</Button> </td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>

      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {handleAddDerivedVariable()}}>Agregar Variable</Button>

      </Form.Group>

      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label" htmlFor="edit-filters">Opciones para: </Form.Label>
        <Form.Select
          key={selectedDerivedVariable ? selectedDerivedVariable.id : 'no-selection'}
          id="edit-alias"
          name="alias"
          value={selectedDerivedVariable ? derivedVariables.findIndex(variable => variable.id === selectedDerivedVariable.id) : ""}
          onChange={(e) => {
            setSelectedDerivedVariable(derivedVariables[e.target.value]);
          }}
        >
          <option value="" defaultValue="selected">- Select -</option>
          { derivedVariables && derivedVariables.map((item, itemId) => <option key={item.id} value={itemId}>{item.selectLabel}</option>) }
        </Form.Select>


      </Form.Group>
      <Form.Group className="admin-content-group">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Valor</th>
            <th>Label</th>
            <th>Save</th>
          </tr>
        </thead>
        <tbody>
          {
            selectedDerivedVariable?.checkItems && selectedDerivedVariable.checkItems.map((item, itemId) => {
              return (
                <tr>
                  <td>{itemId + 1}</td>
                  <td>
                    <Form.Control
                      placeholder="Valor"
                      defaultValue={ selectedDerivedVariable.checkItems[itemId].variableValue }
                      value={ derivedVariablesFormData[selectedDerivedVariable.id] ? derivedVariablesFormData[selectedDerivedVariable.id].checkItems[itemId].variableValue : selectedDerivedVariable.checkItems[itemId].variableValue }
                      onChange={ (e) => {
                        let formData = {
                          ...derivedVariablesFormData,
                          [selectedDerivedVariable.id] : {
                            'variableName': derivedVariablesFormData[selectedDerivedVariable.id] ? derivedVariablesFormData[selectedDerivedVariable.id]['variableName'] : selectedDerivedVariable.variableName,
                            'selectLabel': derivedVariablesFormData[selectedDerivedVariable.id] ? derivedVariablesFormData[selectedDerivedVariable.id]['selectLabel'] : selectedDerivedVariable.selectLabel,
                            'checkGroupLabel': derivedVariablesFormData[selectedDerivedVariable.id] ? derivedVariablesFormData[selectedDerivedVariable.id]['checkGroupLabel'] : selectedDerivedVariable.checkGroupLabel,
                            'checkItems': derivedVariablesFormData[selectedDerivedVariable.id] ? derivedVariablesFormData[selectedDerivedVariable.id]['checkItems'] : selectedDerivedVariable.checkItems,
                          }
                        };

                        formData[selectedDerivedVariable.id].checkItems[itemId] = {
                          'variableValue': e.target.value,
                          'label': formData[selectedDerivedVariable.id].checkItems[itemId].label
                        }

                        setDerivedVariablesFormData(formData);
                      } }  
                    />
                  </td>
                  <td>
                    <Form.Control
                      placeholder="Etiqueta"
                      defaultValue={ selectedDerivedVariable.checkItems[itemId].label }
                      value={ derivedVariablesFormData[selectedDerivedVariable.id] ? derivedVariablesFormData[selectedDerivedVariable.id].checkItems[itemId].label : selectedDerivedVariable.checkItems[itemId].label }
                      onChange={ (e) => {
                        let formData = {
                          ...derivedVariablesFormData,
                          [selectedDerivedVariable.id] : {
                            'variableName': derivedVariablesFormData[selectedDerivedVariable.id] ? derivedVariablesFormData[selectedDerivedVariable.id]['variableName'] : selectedDerivedVariable.variableName,
                            'selectLabel': derivedVariablesFormData[selectedDerivedVariable.id] ? derivedVariablesFormData[selectedDerivedVariable.id]['selectLabel'] : selectedDerivedVariable.selectLabel,
                            'checkGroupLabel': derivedVariablesFormData[selectedDerivedVariable.id] ? derivedVariablesFormData[selectedDerivedVariable.id]['checkGroupLabel'] : selectedDerivedVariable.checkGroupLabel,
                            'checkItems': derivedVariablesFormData[selectedDerivedVariable.id] ? derivedVariablesFormData[selectedDerivedVariable.id]['checkItems'] : selectedDerivedVariable.checkItems,
                          }
                        };

                        formData[selectedDerivedVariable.id].checkItems[itemId] = {
                          'variableValue': formData[selectedDerivedVariable.id].checkItems[itemId].variableValue,
                          'label': e.target.value
                        }

                        setDerivedVariablesFormData(formData);
                      } }  
                    />
                  </td>
                  <td><Button _type="submit" className="admin-add-item-button" onClick={() => {saveDerivedVariable(selectedDerivedVariable.id);}}>Guardar</Button> | <Button _type="submit" className="admin-delete-item-button" onClick={() => {handleDeleteDerivedOption(itemId)}}>Eliminar</Button></td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>
      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {handleAddDerivedOption()}}>Agregar Opción</Button>
      </Form.Group>
    </Form>
    </>
  )

  return (
    <Container fluid>
      <Row>
          <Col xs={2} >
            <Sidebar />
          </Col>
          <Col xs={10} className="admin-content">
            <Card>
              <Card.Header>Variables disponibles para Derivar</Card.Header>
              <Card.Body>{ derivedFormContent }</Card.Body>
            </Card>
          </Col> 
      </Row>
    </Container>
  )
}
